import { useEffect, useState } from 'react'

export default function useSSR() {
    const [isSSR, setIsSSR] = useState(true)

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsSSR(false)
        }
    }, [])

    return isSSR
}
